import store from '../store'
import { getValueByPath } from '../utils/helpers'

export function entityBranding(name, fallback) {
  return (
    getValueByPath(store.getters['session/entityBranding'], name) || fallback
  )
}
